export const heroStats = [
  { label: '收录动漫', value: '12,000+' },
  { label: '每日更新', value: '200+' },
  { label: '漫友社区', value: '800万+' },
];

export const indexTopics = [
  { title: '热血少年', desc: '燃爆青春的战斗史诗，信念与伙伴的热血征程', icon: 'ri-fire-line', color: 'primary' },
  { title: '恋爱甜宠', desc: '心动瞬间与甜蜜日常，治愈系浪漫物语', icon: 'ri-heart-line', color: 'accent' },
  { title: '悬疑推理', desc: '层层反转的烧脑剧情，真相永远在意料之外', icon: 'ri-search-eye-line', color: 'secondary' },
  { title: '搞笑日常', desc: '笑到停不下来的沙雕名场面合集', icon: 'ri-emotion-laugh-line', color: 'accent' },
  { title: '奇幻冒险', desc: '异世界转生与魔法旅程，想象力无边界', icon: 'ri-rocket-line', color: 'primary' },
  { title: '古风国漫', desc: '国风美学巅峰，水墨丹青中的江湖与仙侠', icon: 'ri-brush-line', color: 'secondary' },
  { title: '韩漫精选', desc: '高人气韩漫全集中文版，剧情人设双双在线', icon: 'ri-star-line', color: 'accent' },
];

export const contactInfo = {
  title: '联系投稿',
  desc: '有好的作品推荐？想成为我们的内容合作方？欢迎动漫创作者、汉化组、版权方与我们联系。51动漫致力于打造开放共赢的动漫内容生态。',
  items: [
    { label: '投稿合作', icon: 'ri-mail-send-line', value: 'tougao@51anime.com' },
    { label: '商务洽谈', icon: 'ri-briefcase-line', value: 'biz@51anime.com' },
    { label: '版权事务', icon: 'ri-shield-check-line', value: 'copyright@51anime.com' },
  ],
};

export const carouselItems = [
  {
    title: '《咒术回战》最终章',
    tag: '燃爆今夏',
    desc: '咒术高专的宿命对决迎来终局，五条悟与宿傩的终极之战震撼上演。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20Jujutsu%20Kaisen%20inspired%20scene%20with%20dramatic%20action%20pose%2C%20dark%20energy%20effects%2C%20Japanese%20urban%20fantasy%20atmosphere%2C%20warm%20crimson%20and%20black%20color%20scheme%2C%20cinematic%20lighting%2C%20clean%20composition%20on%20soft%20gradient%20background&width=800&height=500&seq=carousel-01-jujutsu&orientation=landscape',
  },
  {
    title: '《鬼灭之刃》锻刀村篇',
    tag: '经典重温',
    desc: '炭治郎与霞柱在锻刀村迎战上弦之鬼，刀光剑影中的热血激战。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20style%20demon%20slayer%20inspired%20scene%20with%20swordsman%20and%20flame%20effects%2C%20traditional%20Japanese%20village%20setting%2C%20warm%20orange%20and%20deep%20red%20tones%2C%20dynamic%20composition%2C%20soft%20gradient%20background%20with%20subtle%20textures&width=800&height=500&seq=carousel-02-kimetsu&orientation=landscape',
  },
  {
    title: '《间谍过家家》第二季',
    tag: '人气爆款',
    desc: '伪装家庭的爆笑日常再开，阿尼亚的校园冒险与家庭任务同步进行。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20wholesome%20family%20scene%20with%20spy%20theme%2C%20playful%20pink-haired%20girl%20character%2C%20warm%20cozy%20home%20interior%20setting%2C%20soft%20pastel%20and%20cream%20color%20palette%2C%20gentle%20lighting%2C%20clean%20illustration%20style%20on%20light%20background&width=800&height=500&seq=carousel-03-spyfamily&orientation=landscape',
  },
  {
    title: '《我独自升级》',
    tag: '韩漫巅峰',
    desc: '从最弱猎人成长为最强之王，程肖宇的逆袭之路燃爆全场。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20manhwa%20style%20dark%20fantasy%20scene%20with%20shadow%20warrior%20and%20glowing%20purple%20energy%2C%20dungeon%20portal%20atmosphere%2C%20epic%20scale%2C%20deep%20navy%20and%20violet%20color%20palette%2C%20cinematic%20composition%2C%20dramatic%20rim%20lighting%20on%20dark%20background&width=800&height=500&seq=carousel-04-sololeveling&orientation=landscape',
  },
  {
    title: '《葬送的芙莉莲》',
    tag: '口碑神作',
    desc: '精灵魔法使的漫长旅途，在时间中追寻生命与羁绊的真正意义。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20fantasy%20illustration%20with%20elf%20mage%20in%20flowing%20robes%20walking%20through%20flowering%20meadow%2C%20nostalgic%20atmosphere%2C%20soft%20golden%20hour%20lighting%2C%20warm%20earth%20tones%20and%20gentle%20greens%2C%20peaceful%20composition%20on%20light%20gradient%20background&width=800&height=500&seq=carousel-05-frieren&orientation=landscape',
  },
  {
    title: '《全职猎人》暗黑大陆',
    tag: '万众期待',
    desc: '猎人协会启程前往暗黑大陆，小杰与奇犽的全新冒险拉开帷幕。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20adventure%20scene%20with%20young%20hunters%20facing%20mysterious%20dark%20continent%2C%20giant%20creatures%20silhouettes%2C%20epic%20journey%20theme%2C%20warm%20golden%20and%20emerald%20green%20color%20scheme%2C%20cinematic%20wide%20composition%20on%20gradient%20background&width=800&height=500&seq=carousel-06-hunter&orientation=landscape',
  },
];

export const updatesList = [
  { time: '07-28 18:30', title: '《咒术回战》第268话 已更新', tag: '最新' },
  { time: '07-28 16:15', title: '《海贼王》第1131话 中文化完成', tag: '热门' },
  { time: '07-28 14:00', title: '《坂本日常》第189话 上线', tag: '推荐' },
  { time: '07-28 11:45', title: '《蓝色监狱》第283话 全彩版发布', tag: '最新' },
  { time: '07-28 09:30', title: '《电锯人》第185话 中文首发', tag: '热门' },
  { time: '07-27 22:00', title: '《怪兽8号》第120话 更新完毕', tag: '推荐' },
  { time: '07-27 19:15', title: '《物理魔法使马修》第168话 上线', tag: '最新' },
  { time: '07-27 16:00', title: '《黑执事》最终章第210话 更新', tag: '热门' },
  { time: '07-27 12:30', title: '《迷宫饭》第102话 美食冒险继续', tag: '推荐' },
];

export const cardItems = [
  {
    title: '鬼灭之刃 无限城篇',
    tag: '日漫',
    desc: '炭治郎一行潜入无限城，与上弦之鬼展开最终决战。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20art%20style%20with%20demon%20slayer%20character%20holding%20katana%2C%20dramatic%20red%20and%20black%20color%20scheme%2C%20Japanese%20pattern%20elements%2C%20clean%20portrait%20composition%20on%20simple%20dark%20gradient%20background%2C%20editorial%20quality&width=600&height=850&seq=card-01-kimetsu&orientation=portrait',
  },
  {
    title: '间谍过家家 第三季',
    tag: '日漫',
    desc: '福杰一家的伪装生活继续，阿尼亚交到了新朋友。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20art%20with%20cute%20pink-haired%20girl%20and%20family%20theme%2C%20soft%20pastel%20pink%20and%20cream%20color%20palette%2C%20playful%20composition%2C%20clean%20portrait%20on%20light%20gradient%20background%2C%20editorial%20illustration&width=600&height=850&seq=card-02-spyfamily&orientation=portrait',
  },
  {
    title: '我独自升级 第二季',
    tag: '韩漫',
    desc: '暗影君主的传奇继续，S级猎人的全新挑战降临。',
    image: 'https://readdy.ai/api/search-image?query=Manhwa%20cover%20art%20style%20dark%20fantasy%20character%20with%20shadow%20powers%2C%20purple%20and%20black%20color%20scheme%2C%20cool%20aura%20effects%2C%20standing%20pose%20portrait%20on%20dark%20gradient%20background%2C%20clean%20illustration&width=600&height=850&seq=card-03-sololeveling&orientation=portrait',
  },
  {
    title: '镖人 西域篇',
    tag: '国漫',
    desc: '刀马的西域之行暗藏杀机，大漠孤烟中的江湖恩怨。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20with%20martial%20warrior%20in%20desert%20setting%2C%20ink%20wash%20painting%20style%2C%20warm%20earth%20tones%20and%20golden%20accents%2C%20strong%20brushwork%20portrait%20on%20parchment%20gradient%20background%2C%20wuxia%20aesthetic&width=600&height=850&seq=card-04-biaoren&orientation=portrait',
  },
  {
    title: '电锯人 第二部',
    tag: '日漫',
    desc: '三鹰朝与战争恶魔的契约，校园生活暗流涌动。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20art%20with%20chainsaw-themed%20character%2C%20grunge%20and%20punk%20aesthetic%2C%20orange%20and%20black%20color%20scheme%2C%20dynamic%20action%20portrait%20on%20textured%20dark%20gradient%20background%2C%20edgy%20illustration%20style&width=600&height=850&seq=card-05-chainsaw&orientation=portrait',
  },
  {
    title: '全职猎人 暗黑大陆',
    tag: '日漫',
    desc: '猎人世界最危险的禁区，小杰与金父子的冒险。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20art%20with%20young%20adventurer%20in%20green%20outfit%2C%20nature%20and%20wilderness%20theme%2C%20emerald%20green%20and%20golden%20color%20scheme%2C%20adventure%20portrait%20on%20soft%20gradient%20background%2C%20clean%20illustration&width=600&height=850&seq=card-06-hunter&orientation=portrait',
  },
  {
    title: '一人之下 唐门篇',
    tag: '国漫',
    desc: '异人界的唐门秘辛揭晓，张楚岚踏上西南之旅。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20with%20modern%20martial%20arts%20character%2C%20urban%20fantasy%20style%2C%20dark%20blue%20and%20silver%20color%20scheme%2C%20cool%20portrait%20on%20gradient%20background%2C%20clean%20contemporary%20illustration&width=600&height=850&seq=card-07-yiren&orientation=portrait',
  },
];

export const rankingItems = [
  { rank: 1, title: '咒术回战', tag: 'JUMP系', hot: '98.7', trend: 'up', change: '+2' },
  { rank: 2, title: '我独自升级', tag: '韩漫', hot: '97.2', trend: 'up', change: '+5' },
  { rank: 3, title: '鬼灭之刃', tag: 'JUMP系', hot: '95.8', trend: 'down', change: '-1' },
  { rank: 4, title: '间谍过家家', tag: '日常', hot: '93.4', trend: 'up', change: '+3' },
  { rank: 5, title: '镖人', tag: '国漫', hot: '91.6', trend: 'new', change: 'NEW' },
];

export const featureItems = [
  {
    title: '海量资源 全集中文',
    desc: '覆盖韩漫、日漫、国漫三大板块，12000+ 部作品全集中文版，每周新增 200+ 话，追更永不断档。',
    icon: 'ri-stack-line',
  },
  {
    title: '下拉式阅读 沉浸体验',
    desc: '专为移动端优化的下拉式阅读模式，纵向无缝衔接，左右滑动翻页，还原纸质漫画阅读感。',
    icon: 'ri-scroll-to-bottom-line',
  },
  {
    title: '智能追更 永不错过',
    desc: '订阅喜爱的作品，更新第一时间推送通知，个性化书架管理，追更进度一目了然。',
    icon: 'ri-notification-3-line',
  },
];

export const commentItems = [
  {
    name: '追风少年',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20boy%20avatar%20icon%2C%20simple%20flat%20illustration%2C%20warm%20orange%20hair%2C%20friendly%20expression%2C%20clean%20circle%20composition%20on%20light%20background&width=120&height=120&seq=avatar-01&orientation=squarish',
    text: '51动漫真的是我用过最舒服的看漫平台！下拉式阅读太爽了，不用翻页点来点去，一口气看完一话完全不累。而且更新速度超级快！',
    time: '2 小时前',
    likes: 328,
  },
  {
    name: '樱花下的猫',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20icon%2C%20simple%20flat%20illustration%2C%20pink%20hair%2C%20sweet%20smile%2C%20clean%20circle%20composition%20on%20light%20background&width=120&height=120&seq=avatar-02&orientation=squarish',
    text: '韩漫资源真的全！找了很久的《我独自升级》全集中文版在这里找到了，翻译质量也很高，已经推荐给身边所有漫友了~',
    time: '5 小时前',
    likes: 256,
  },
  {
    name: '动漫老司机',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20character%20avatar%20icon%2C%20simple%20flat%20illustration%2C%20dark%20hair%2C%20calm%20expression%2C%20clean%20circle%20composition%20on%20light%20background&width=120&height=120&seq=avatar-03&orientation=squarish',
    text: '追了十几年漫画，51动漫的国漫板块做得真心不错。《镖人》《一人之下》这些精品国漫更新及时，画质也高清，国漫崛起！',
    time: '昨天',
    likes: 189,
  },
  {
    name: '二次元小透明',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20character%20avatar%20icon%2C%20simple%20flat%20illustration%2C%20blue%20hair%2C%20happy%20expression%2C%20clean%20circle%20composition%20on%20light%20background&width=120&height=120&seq=avatar-04&orientation=squarish',
    text: '界面简洁没有广告干扰，书架功能也很实用，收藏的作品更新了会有小红点提醒，再也不用担心漏追了！希望平台越来越好~',
    time: '2 天前',
    likes: 142,
  },
];

export const topicItems = [
  { name: '咒术回战268', hot: '火热' },
  { name: '我独自升级', hot: '火爆' },
  { name: '鬼灭无限城', hot: '火热' },
  { name: '海贼王1131', hot: '热门' },
  { name: '电锯人185', hot: '热门' },
  { name: '间谍过家家', hot: '热门' },
  { name: '国漫崛起', hot: '火热' },
  { name: '韩漫推荐', hot: '热门' },
  { name: '新番速递', hot: '推荐' },
  { name: '下拉式阅读', hot: '推荐' },
];

export const aboutInfo = {
  title: '关于51动漫',
  paragraphs: [
    '51动漫是国内领先的动漫内容聚合平台，致力于为广大动漫爱好者提供海量韩漫、日漫、国漫免费全集资源。自上线以来，平台累计收录超 12000 部动漫作品，覆盖热血、恋爱、悬疑、搞笑、奇幻、古风等全品类题材，日均服务数百万漫友。',
    '平台采用独创的下拉式阅读技术，专为移动端优化纵向无缝阅读体验，配合智能书架与更新推送系统，让追更变得前所未有的简单。我们与众多汉化组、版权方建立了深度合作关系，确保内容更新及时、翻译质量可靠。',
    '51动漫坚信，好的动漫值得被更多人看到。我们将持续丰富内容库，优化阅读体验，打造最懂漫友的动漫平台。',
  ],
};

export const appInfo = {
  title: 'APP下载',
  desc: '51动漫 App 已上架各大应用商店，支持 iOS 与 Android 双平台。下载 App 享受更流畅的下拉式阅读体验、离线缓存、夜间模式等专属功能。',
  features: ['下拉式流畅阅读', '离线缓存随时看', '夜间模式护眼', '更新秒速推送'],
};

export const mediaItems = [
  {
    title: '《咒术回战》名场面混剪',
    type: 'MAD',
    desc: '高燃战斗场面全收录，五条悟 VS 宿傩巅峰对决。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20action%20scene%20thumbnail%20with%20dramatic%20fight%20between%20two%20powerful%20characters%2C%20energy%20effects%2C%20dark%20crimson%20and%20black%20color%20scheme%2C%20cinematic%20composition%2C%20video%20player%20overlay%20style%20on%20gradient%20background&width=700&height=400&seq=media-01-jujutsu&orientation=landscape',
  },
  {
    title: '《鬼灭之刃》无限列车篇',
    type: '剧场版',
    desc: '炼狱杏寿郎的炎之呼吸，燃尽一切的终极一战。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20movie%20scene%20thumbnail%20with%20flame%20swordsman%20in%20train%20setting%2C%20warm%20orange%20and%20golden%20flame%20effects%2C%20dramatic%20lighting%2C%20cinematic%20composition%20on%20dark%20gradient%20background&width=700&height=400&seq=media-02-kimetsu&orientation=landscape',
  },
  {
    title: '《一人之下》唐门篇PV',
    type: '预告',
    desc: '唐门暗器与异人绝技的碰撞，国漫打斗新高度。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20martial%20arts%20scene%20thumbnail%2C%20ink%20wash%20and%20modern%20fusion%2C%20dynamic%20fight%20pose%2C%20dark%20blue%20and%20silver%20color%20scheme%2C%20cinematic%20composition%20on%20gradient%20background&width=700&height=400&seq=media-03-yiren&orientation=landscape',
  },
  {
    title: '《葬送的芙莉莲》旅途集锦',
    type: 'MAD',
    desc: '精灵的千年之旅，那些被时间雕刻的温柔瞬间。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20fantasy%20journey%20scene%20thumbnail%20with%20elf%20mage%20and%20companions%2C%20nostalgic%20atmosphere%2C%20soft%20golden%20and%20green%20color%20palette%2C%20peaceful%20composition%20on%20light%20gradient%20background&width=700&height=400&seq=media-04-frieren&orientation=landscape',
  },
];

export const faqItems = [
  {
    q: '51动漫需要注册才能观看吗？',
    a: '大部分内容无需注册即可免费观看。注册账号后可使用书架收藏、更新提醒、阅读历史同步等个性化功能，追更体验更佳。',
  },
  {
    q: '支持哪些设备观看动漫？',
    a: '51动漫全面适配 PC 浏览器、手机浏览器、平板设备。同时提供 iOS 和 Android 原生 App，下载 App 可享受下拉式阅读、离线缓存等专属功能。',
  },
  {
    q: '更新频率是怎样的？',
    a: '热门连载作品通常在日本/韩国首发后 24 小时内更新中文版，日均更新量超 200 话。可订阅作品获取更新推送，第一时间知晓最新内容。',
  },
  {
    q: '下拉式阅读是什么意思？',
    a: '下拉式阅读是51动漫独创的纵向无缝阅读模式，将一整话内容拼接为纵向长图，通过手指上下滑动即可流畅阅读，无需反复点击翻页按钮，还原纸质漫画的沉浸感。',
  },
  {
    q: '如何向平台推荐作品或投稿？',
    a: '欢迎通过联系投稿页面与我们沟通。动漫创作者、汉化组可将作品发送至投稿邮箱，版权方可通过商务合作邮箱洽谈版权授权事宜。',
  },
];